/**
 * 상담 모드 타입 정의
 * V1153: 조직 단위 상담 모드 관리
 */

export type ConsultationModeType = "DESK" | "AI" | "AI_ASSIST" | "AI_PIPELINE";

export interface ConsultationModeConfig {
  enabled: boolean;
  currentMode: ConsultationModeType;
  configuredMode: ConsultationModeType;
  ringTimeoutSeconds: number;
  allowedModes: ConsultationModeType[];
  hasKctDid: boolean;
  forceOverride?: {
    mode: ConsultationModeType;
    at: string;
    by: string;
  };
  updatedAt: string | null;
  updatedBy: string | null;
  recentChanges: ConsultationModeLogEntry[];
}

export interface ConsultationModeLogEntry {
  previousMode: ConsultationModeType | null;
  newMode: ConsultationModeType;
  changedBy: string;
  changeSource: string;
  reason: string | null;
  createdAt: string;
}

export interface ConsultationModeUpdateRequest {
  mode: ConsultationModeType;
  ringTimeoutSeconds?: number;
}

export const CONSULTATION_MODE_LABELS: Record<ConsultationModeType, string> = {
  DESK: "데스크 상담",
  AI: "AI 상담",
  AI_ASSIST: "AI 상담 보조",
  AI_PIPELINE: "AI Pipeline",
};

export const CONSULTATION_MODE_DESCRIPTIONS: Record<
  ConsultationModeType,
  string
> = {
  DESK: "모든 전화를 상담원이 직접 응대합니다",
  AI: "AI가 모든 전화를 자동 응대합니다",
  AI_ASSIST: "상담원 미응답 시 AI가 대신 응대합니다",
  AI_PIPELINE: "LiveKit 파이프라인으로 AI가 응대합니다",
};
